module.exports = __webpack_public_path__ + "static/media/temistocles.f0437aa8.png";